import React from 'react';
import { Link } from 'react-router';

class Header extends React.Component{

  constructor(props) {
    super(props);

    this.state = {
      hcCurrent : 0,
      hedcuts : shuffle([
        'landing-page-images/hedcuts/HC-GS607_Drawin_G_20140516141524.jpg',
        'landing-page-images/hedcuts/HC-GS668_Drawin_G_20140609084704.jpg',
        'landing-page-images/hedcuts/HC-GS769_Drawin_G_20140626151515.jpg',
        'landing-page-images/hedcuts/HC-GS770_Panda_G_20140622173021.jpg',
        'landing-page-images/hedcuts/HC-GT102_charac_G_20140917114523.jpg',
        'landing-page-images/hedcuts/HC-GT196_Coffee_G_20141029173012.jpg'])
    }

    this.handleKeypress = this.handleKeypress.bind(this);
    this.swapHedcut = this.swapHedcut.bind(this);

  }

  swapHedcut(forwards) {
    let hcs = this.state.hedcuts;
    let c = this.state.hcCurrent;
    let n;
    if(forwards) {
      n = c+1 < hcs.length ? c+1 : 0;
    } else {
      n = c-1 >= 0 ? c-1 : c.length-1;
    }
    this.setState({
      hcCurrent : n
    });
  }

  handleKeypress(event) {
    if(event.which == 37) {
      this.swapHedcut(false)
    } else if(event.which == 39) {
      this.swapHedcut(true)
    }
  }

  componentWillMount() {
    this.handleKeypress = throttle(this.handleKeypress, 200);
  }

  componentDidMount() {
    document.querySelector('body')
      .addEventListener('keydown', this.handleKeypress);
  }

  componentWillUnmount() {
    document.querySelector('body')
      .removeEventListener('keydown', this.handleKeypress);
  }


  render() {

    let hedcut = this.state.hedcuts[ this.state.hcCurrent ];

    return(
      <header>
      	<div className="header-meta">
      		<div className="logo-wrap">
            <Link to="/">
              <img src="./landing-page-images/wsjlogo.png"/>
              <h1>Graphics</h1>
            </Link>
      		</div>
      		<figure id="hc" className="headcut"
            style={{backgroundImage:'url('+hedcut+')'}}
            onClick={ this.swapHedcut }>
          </figure>
      	</div>
      	<div className="dek">
      		<p>Projects from The Wall Street Journal’s Graphics Team</p>
  				<nav>
  					<li>
              <Link to="jobs" className="jobs">Come work with us</Link>
  					</li>
  					<li>
  						<a className="github" href="https://github.com/wsj">GitHub</a>
  					</li>
            <li>
  						<a className="twitter" href="https://twitter.com/wsjgraphics">Twitter</a>
  					</li>
  				</nav>
      	</div>
      </header>
    )
  }
};

/* Fisher-Yates Shuffle by AJ ONeal */
function shuffle(array) {
  var currentIndex = array.length, temporaryValue, randomIndex;

  // While there remain elements to shuffle...
  while (0 !== currentIndex) {

    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;

    // And swap it with the current element.
    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }

  return array;
}

/* Throttle function from Underscore.js v1.8.3 */
function throttle(func, wait, options) {
  var context, args, result;
  var timeout = null;
  var previous = 0;
  if (!options) options = {};
  var later = function() {
    previous = options.leading === false ? 0 : new Date().getTime();
    timeout = null;
    result = func.apply(context, args);
    if (!timeout) context = args = null;
  };
  return function() {
    var now = new Date().getTime();
    if (!previous && options.leading === false) previous = now;
    var remaining = wait - (now - previous);
    context = this;
    args = arguments;
    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
      previous = now;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    } else if (!timeout && options.trailing !== false) {
      timeout = setTimeout(later, remaining);
    }
    return result;
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js